import React from 'react'
import ClassNames from 'classnames'
import { RadarGraphStyle } from './styled'

import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Legend,
} from 'recharts'
//https://recharts.org/en-US/api/RadarChart

export class RadarGraph extends React.PureComponent {
  render() {
    const { className, data } = this.props

    return (
      <RadarGraphStyle className={ClassNames('radar-graph-control', className)}>
        <RadarChart
          cx={300}
          cy={250}
          outerRadius={200}
          width={600}
          height={500}
          data={data}
        >
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis angle={90} domain={[0, 5]} scale="linear" />
          <Radar name="Mike" dataKey="A" stroke="#8884d8" fillOpacity={0} />
        </RadarChart>
      </RadarGraphStyle>
    )
  }
}
